var constructName = function (data) {
    if (data.firstName) {
        return "".concat(data.firstName || '', " ").concat(data.middleName || '', " ").concat(data.lastName || '');
    }
    if (data.first_name) {
        return "".concat(data.first_name || '', " ").concat(data.middle_name || '', " ").concat(data.last_name || '');
    }
    return data.name;
};
export default constructName;
